import request from './request'

export default {
  index() {
    return request.post('/captcha/index')
  },
}
